export const CRED = {
  RAZORPAY_KEY: "rzp_live_pQXvkbWD4oVatb",
  RAZORPAY_TEST_KEY: "rzp_test_6LsjO5j4RhDFnk",
  RAZORPAY_SECRET_KEY: "I4Em3urWryYA5E6OTK95AOQa",
};
